import { render, staticRenderFns } from "./WebHead.vue?vue&type=template&id=351988b3&scoped=true"
import script from "./WebHead.vue?vue&type=script&lang=js"
export * from "./WebHead.vue?vue&type=script&lang=js"
import style0 from "./WebHead.vue?vue&type=style&index=0&id=351988b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351988b3",
  null
  
)

export default component.exports